import type { ResolutionExample } from '../api/knowledgeApi'

export function exampleState(e: ResolutionExample) {
  if (e.revokedAt) return { key: 'revoked', label: 'Revoked' }
  if (e.action === 'category' || e.action === 'generic' || e.action === 'link')
    return { key: 'local', label: 'Applied in AMS' }
  if (e.appliedStatus === 'applied' || e.appliedStatus === 'already')
    return { key: 'applied', label: 'Applied by build' }
  if (e.appliedStatus === 'no_match' || e.appliedStatus === 'conflict')
    return { key: 'attention', label: 'Build needs attention' }
  return {
    key: 'waiting',
    label: e.exportedAt ? 'Exported · awaiting build' : 'Accepted · awaiting export',
  }
}

export function exampleChange(e: ResolutionExample) {
  const p = e.payload || {}
  const d = e.decisionPayload || {}
  const names = d.conceptNames || Object.values(p.names || {})
  const fallback = e.conceptNames.filter(Boolean).join(' + ') || 'Concept'
  switch (e.action) {
    case 'merge':
      return { before: names.join(' + ') || fallback, after: p.canonicalName || fallback }
    case 'category':
      return {
        before: String(d.from ?? p.previous ?? 'Uncategorised'),
        after: String(d.to ?? p.category ?? 'Category'),
      }
    case 'generic':
      return {
        before: `Weight ${d.from ?? 'automatic'}`,
        after: `Weight ${d.to ?? p.suggestedWeight ?? 0.1}`,
      }
    case 'reject':
      return { before: d.conceptName || fallback, after: 'Remove from the next graph build' }
    case 'split':
      return {
        before: d.conceptName || fallback,
        after:
          d.groups?.map((g) => g.join(', ')).join(' | ') ||
          p.splitNames?.join(', ') ||
          'Separate concepts',
      }
    default:
      return { before: fallback, after: p.relationType?.replace(/_/g, ' ') || 'Typed relation' }
  }
}
